import { Star } from "lucide-react";
import { ASSETS } from "@/lib/assets";
import { useWatchlist } from "@/context/WatchlistContext";
import { useLang } from "@/context/LanguageContext";

export function WatchlistBar() {
  const { has, toggle, isEmpty } = useWatchlist();
  const { t, lang } = useLang();
  const lbl = (a) => (lang === "en" && a.labelEn ? a.labelEn : a.label);
  return (
    <div className="rounded-lg border border-[#222733] bg-[#0E1118] p-3" data-testid="watchlist-bar">
      <div className="mb-2 flex items-center gap-2">
        <Star className="h-4 w-4 text-amber-400" />
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-300">{t("wl.title")}</span>
        <span className="text-[10px] text-slate-600">
          {isEmpty ? t("wl.hintEmpty") : t("wl.hint")}
        </span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {ASSETS.map((a) => {
          const on = has(a.id);
          return (
            <button
              key={a.id}
              onClick={() => toggle(a.id)}
              data-testid={`watch-toggle-${a.id}`}
              className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors ${
                on
                  ? "border-amber-500/60 bg-amber-500/15 text-amber-200"
                  : "border-[#222733] bg-[#11141A] text-slate-400 hover:text-white"
              }`}>
              <span>{a.flag}</span>
              {lbl(a)}
              {on && <Star className="h-3 w-3 fill-amber-400 text-amber-400" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
